

const initialState = {
    loading: false,
    payoutQueryInternal: [],
    error: "",
};


const payoutQueryInternalReducer = (state = initialState, action) => {
    switch (action.type) {
        case "RAISE_PAYOUT_QUERY_INTERNAL_SUCCESS":
            return {
                ...state,
                payoutQueryInternal: action.payload,
                loading: false,
            };

        case "RAISE_PAYOUT_QUERY_INTERNAL_FAILURE":
            return {
                ...state,
                error: action.payload,
                payoutQueryInternal: [],
                loading: false,
            };

        default:
            return state;
    }
};

export default payoutQueryInternalReducer;
